import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useEffectOnce } from 'usehooks-ts';

import { insurerTeamsFetch } from './action';
import { selectFeatureInsurerTeam } from './selector';

export const useInsurerTeamsFetch = () => {
  const dispatch = useDispatch();
  const { teams } = useSelector(selectFeatureInsurerTeam);

  useEffectOnce(() => {
    if (!isEmpty(teams)) return;
    dispatch(insurerTeamsFetch());
  });

  return teams;
};
